import { FiAlertTriangle, FiArrowRight, FiClock, FiBarChart2, FiLogOut } from 'react-icons/fi'
import { useAuth } from '../contexts/AuthContext'
import { Link } from 'react-router-dom'

/**
 * Pantalla de bloqueo cuando el trial ha expirado.
 * - Admin: ve opciones para elegir plan + acceso a reportes
 * - Empleado: ve mensaje de contactar al administrador
 */
export default function TrialExpiradoScreen() {
  const { empleado, empresaInfo, logout } = useAuth()
  const isAdmin = empleado?.rol === 'admin' || empleado?.rol === 'super_admin'

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-8 sm:p-10 text-center">
          {/* Icono */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-2xl mb-6">
            <FiClock className="h-8 w-8 text-amber-600" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">
            Tu período de prueba ha finalizado
          </h1>

          {isAdmin ? (
            <>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Los 14 días de prueba gratuita han terminado. Para seguir usando PresenzIA,
                elige un plan y activa tu suscripción. Tus datos y registros están seguros.
              </p>

              {/* CTA principal */}
              <Link
                to="/suscripcion"
                className="w-full inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold py-4 px-8 rounded-2xl text-base shadow-lg hover:from-blue-700 hover:to-blue-800 transition-all mb-4"
              >
                Elegir plan y activar
                <FiArrowRight className="h-5 w-5" />
              </Link>

              {/* Acceso a reportes */}
              <Link
                to="/reportes"
                className="w-full inline-flex items-center justify-center gap-2 bg-gray-100 text-gray-700 font-semibold py-3 px-6 rounded-xl hover:bg-gray-200 transition-colors mb-6"
              >
                <FiBarChart2 className="h-4 w-4" />
                Acceder a reportes
              </Link>

              {/* Info de precios */}
              <div className="bg-blue-50 rounded-2xl p-5 text-left border border-blue-100 mb-4">
                <p className="text-sm font-semibold text-blue-800 mb-3">Planes disponibles:</p>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-blue-700 font-medium">Pro — cumplimiento legal</span>
                    <span className="text-blue-900 font-bold">desde 1,25 €/emp/mes</span>
                  </div>
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-blue-700 font-medium">Avanzado — control total</span>
                    <span className="text-blue-900 font-bold">desde 2,46 €/emp/mes</span>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              <p className="text-gray-600 mb-6 leading-relaxed">
                El período de prueba de tu empresa ha finalizado. Contacta con tu administrador
                para activar la suscripción y seguir utilizando PresenzIA.
              </p>

              <div className="bg-amber-50 rounded-2xl p-5 border border-amber-100 mb-6">
                <div className="flex items-start gap-3">
                  <FiAlertTriangle className="h-5 w-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <div className="text-left">
                    <p className="text-sm font-semibold text-amber-800">Acceso limitado</p>
                    <p className="text-xs text-amber-700 mt-1">
                      Mientras no se active la suscripción, solo puedes consultar tus reportes e historial.
                    </p>
                  </div>
                </div>
              </div>

              {/* Acceso a reportes para empleados también */}
              <Link
                to="/reportes"
                className="w-full inline-flex items-center justify-center gap-2 bg-gray-100 text-gray-700 font-semibold py-3 px-6 rounded-xl hover:bg-gray-200 transition-colors mb-4"
              >
                <FiBarChart2 className="h-4 w-4" />
                Ver mis reportes
              </Link>
            </>
          )}

          {/* Cerrar sesión */}
          <button
            onClick={logout}
            className="inline-flex items-center gap-2 text-gray-400 hover:text-gray-600 text-sm font-medium transition-colors mt-2"
          >
            <FiLogOut className="h-4 w-4" />
            Cerrar sesión
          </button>
        </div>

        <p className="text-center text-xs text-gray-400 mt-6">
          Tus datos están seguros y se conservarán. Al activar la suscripción, todo seguirá donde lo dejaste.
        </p>
      </div>
    </div>
  )
}
